import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from 'lucide-react';
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

const LanguageSelector: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { toast } = useToast();

  const handleLanguageChange = async (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem('preferred-language', value);
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("User not authenticated");
      const { error } = await supabase
        .from('profiles')
        .update({ preferred_language: value })
        .eq('id', user.id);
      if (error) throw error;
      toast({
        title: t('settings.language'),
        description: t('settings.saveChanges'),
      });
    } catch (error) {
      toast({
        variant: "destructive",
        title: t('settings.language'),
        description: t('settings.saving') + ' failed',
      });
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Globe className="h-4 w-4 text-gebeya-pink" />
        <Label htmlFor="language" className="text-sm font-medium">
          {t('settings.language')}
        </Label>
      </div>
      <p className="text-sm text-gray-600">
        {t('settings.languageDesc')}
      </p>
      <Select value={i18n.language} onValueChange={handleLanguageChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={t('settings.language')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en">
            <div className="flex items-center gap-2">
              <span className="text-lg">🇺🇸</span>
              {t('settings.english')}
            </div>
          </SelectItem>
          <SelectItem value="fr">
            <div className="flex items-center gap-2">
              <span className="text-lg">🇫🇷</span>
              {t('settings.french')}
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSelector; 